var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"toolbar--white action-bar overflow--y",class:{ 'action-bar--ml': !_vm.mainMenuIsOpen },attrs:{"data-js":"get-height","flat":""}},[_c('Breadcrumb',{attrs:{"routes":_vm.breadcrumbItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }